import { Injectable } from '@angular/core';
import { Topic } from './topic';
import { ArcService } from './arc.service'
import { UtilsService } from './utils.service'
import { Observable }  from 'rxjs/Observable';
import { RuntimeService } from './runtime.service'
import { ProjectService } from './project.service'
import { Project } from './project'

@Injectable()
export class TopicService {
  currentTopic: Topic; 

  constructor(
    private arcs: ArcService,
    private rts: RuntimeService,
    private utils: UtilsService,
    private projects: ProjectService
  ) {
    this.arcs.topics = this
    this.projects.topics = this
  }

  init(obj) {
    /*
    obj['topics'].forEach((p) => new Project(this, p['id'], p['title']))
    */
  }

  newFromSaved(p: Project, params: Object) {
    new Topic(this, p, params['id'], params['title'] || '???')
  }

  newTopic() {
    let tid = this.utils.uniqueIdentifier
    if (!tid)
      return
    return new Topic(this, this.rts.currentProject, tid, '')
  }

  save(t: Topic): Observable<any> {
    t.isNew = false
    let obs = this.arcs.run({
      fun: 'saveTopic',
      title: t.title,
      projectId: t.project.id,
      id: t.id
    })
    obs.subscribe((resp) => {

    })
    return obs
  }

  delete(t: Topic): Observable<any> {
    let obs = this.arcs.run({
      fun: 'deleteTopic',
      id: t.id
    })
    obs.subscribe((resp) => t.project.topicsMap.delete(t.id))
    return obs
  }

}



// WEBPACK FOOTER //
// ./src/app/topic.service.ts